import React from 'react';
import Chart from 'react-apexcharts';
import {
  Box,
  Card,
  CardContent,
  Typography,
  useTheme
} from '@material-ui/core';

function DiskUtilization({ classes, data }) {
  const theme = useTheme();

  if (!data || Object.keys(data).length === 0) {
    return null;
  }

  const chartData = {
    options: {
      chart: {
        background: theme.palette.background.paper,
        sparkline: {
          enabled: true
        }
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          hollow: {
            size: '50%'
          },
          track: {
            background: '#e2e2e2',
            strokeWidth: '90%',
            margin: 5
          },
          dataLabels: {
            name: {
              offsetY: 28,
              fontFamily: theme.typography.fontFamily,
              fontSize: 16,
              color: '#111'
            },
            value: {
              offsetY: -20,
              fontSize: 22,
              color: '#111'
            }
          }
        }
      },
      title: {
        text: 'Disk Utilization'
      },
      labels: [' ']
    },
    series: [data['disk.percentUsed']]
  };

  return (
    <Card>
      <Box
        maxWidth={320}
        mx="auto"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <CardContent>
          <Chart
            options={chartData.options}
            series={chartData.series}
            type="radialBar"
            className={classes.chart}
          />
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Disk Usable:{' '}
            {Math.floor(data['disk.usableSpace'] / (1024.0 * 1024.0 * 1024.0))}g
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Disk Total:{' '}
            {Math.floor(data['disk.totalSpace'] / (1024.0 * 1024.0 * 1024.0))}g
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
          >
            Disk Free:{' '}
            {Math.floor(data['disk.freeSpace'] / (1024.0 * 1024.0 * 1024.0))}g
          </Typography>
          <Typography
            align="left"
            color="textSecondary"
            variant="body1"
            component="p"
            style={{ visibility: 'hidden' }}
          >
            {'Disk Utilization'}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}

export default DiskUtilization;
